import ClubAppSettings from './../Club/club-app-settings';

export default class LTClubAppSettings extends ClubAppSettings {
    ContactPhoneToRequests: string = "+79284262460";
    
}